import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilterValues,
  ODataSubFilter
} from '../components/odata-filter/models/odata-filter';
import { FilterOperator, OPERATORS } from '../components/odata-filter/models/operators';
import { SearchValueType } from '../components/odata-filter/models/search-value-type';
import { ODataFilterBuilder } from './odata-filter-builder';

export class EvaluationResponsesFilterModel {
  childFieldName = 'answers';
  targetFieldPrimaryKey = 'questionId';
  subFilter = new ODataSubFilter();
  constructor(
    public filterGroup: FilterGroup,
    public displayName: string,
    public targetField: string,
    public targetFieldId: string,
    public valueType: SearchValueType,
    public values?: any[] | ODataFilterValues[]
  ) {}

  buildFilter(searchValue: any, filterOperator: FilterOperator) {
    if (this.valueType == SearchValueType.String) {
      return this.buildStringTypeFilter(searchValue, filterOperator);
    } else if (this.valueType == SearchValueType.Number) {
      return this.buildNumberTypeFilter(searchValue, filterOperator);
    } else if (this.valueType == SearchValueType.MultiValue) {
      return this.buildEnumeratedTypeFilter(searchValue, filterOperator);
    } else {
      throw new Error('Invalid Operation');
    }
  }

  private buildStringTypeFilter(searchValue: any, filterOperator: FilterOperator) {
    let operatorTypes = OPERATORS[this.valueType];
    if (
      operatorTypes.operators.findIndex(
        (x) => x.displayOperator == filterOperator.displayOperator
      ) == -1
    ) {
      throw new Error('Invalid Operation');
    } else if (filterOperator.displayOperator == FilterOperatorType.isEmpty) {
      return {
        not: {
          [this.targetField]: {
            any: [
              ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId)
            ]
          }
        }
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.isNotEmpty) {
      return {
        [this.targetField]: {
          any: [ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId)]
        }
      };
    } else {
      let filter = {
        [this.targetField]: {
          any: [
            ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId),
            {
              [this.childFieldName]: {
                any: [
                  ODataFilterBuilder.buildStringFilter(
                    'value',
                    searchValue,
                    filterOperator.actualOperator
                  )
                ]
              }
            }
          ]
        }
      };

      if (filterOperator.displayOperator == FilterOperatorType.notContains) return { not: filter };
      return filter;
    }
  }

  private buildNumberTypeFilter(searchValue: any, filterOperator: FilterOperator) {
    let operatorTypes = OPERATORS[this.valueType];

    if (
      operatorTypes.operators.findIndex(
        (x) => x.displayOperator == filterOperator.displayOperator
      ) == -1
    ) {
      throw new Error('Invalid Operation');
    }
    if (filterOperator.displayOperator == FilterOperatorType.isEmpty) {
      return {
        not: {
          [this.targetField]: {
            any: [
              ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId)
            ]
          }
        }
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.isNotEmpty) {
      return {
        [this.targetField]: {
          any: [ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId)]
        }
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.notContains) {
      return {
        [this.targetField]: {
          any: [
            ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId),
            {
              [this.childFieldName]: {
                any: [
                  ODataFilterBuilder.buildNumberFilter(
                    'to_double(value)',
                    searchValue,
                    FilterOperatorType.contains
                  )
                ]
              }
            }
          ]
        }
      };
    } else {
      return {
        [this.targetField]: {
          any: [
            ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId),
            {
              [this.childFieldName]: {
                any: [
                  ODataFilterBuilder.buildNumberFilter(
                    'to_double(value)',
                    searchValue,
                    filterOperator.actualOperator
                  )
                ]
              }
            }
          ]
        }
      };
    }
  }

  private buildEnumeratedTypeFilter(
    searchValue: ODataFilterValues[],
    filterOperator: FilterOperator
  ) {
    let _searchValue =
      searchValue && searchValue.length ? searchValue.map((x) => x.searchValue) : [];
    if (filterOperator.displayOperator == FilterOperatorType.in) {
      return {
        [this.targetField]: {
          any: [
            {
              [this.childFieldName]: {
                any: [ODataFilterBuilder.buildArrayFilter('id', _searchValue)]
              }
            }
          ]
        }
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.notIn) {
      return {
        not: {
          [this.targetField]: {
            any: [
              {
                [this.childFieldName]: {
                  any: [ODataFilterBuilder.buildArrayFilter('id', _searchValue)]
                }
              }
            ]
          }
        },
        [this.targetField]: {
          any: ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId)
        }
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.isEmpty) {
      return {
        not: {
          [this.targetField]: {
            any: [
              ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId)
            ]
          }
        }
      };
    } else if (filterOperator.displayOperator == FilterOperatorType.isNotEmpty) {
      return {
        [this.targetField]: {
          any: [ODataFilterBuilder.buildGuidFilter(this.targetFieldPrimaryKey, this.targetFieldId)]
        }
      };
    } else throw new Error('Invalid Operation');
  }
}
